import { render, staticRenderFns } from "./GeneralErrorIconV2.vue?vue&type=template&id=1fb566f0"
import script from "./GeneralErrorIconV2.vue?vue&type=script&lang=js"
export * from "./GeneralErrorIconV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports